<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="2">
          Type
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="3" class="py-0">
          <v-radio-group row v-model="type">
            <v-radio label="Not Invoice" :value="0"></v-radio>
            <v-radio label="Invoiced" :value="1"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2">
          <v-btn color="primary" @click="find" class="mr-2">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn color="success" @click="excel">
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-text-field
          flat
          dense
          outlined
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" dense :search="search">
        <template v-slot:item.no="{ item }">
          {{ items.findIndex(x => x === item) + 1 }}
        </template>
        <template v-slot:item.poAmount="{ item }">
          {{ formatPrice(item.poAmount) }}
        </template>
        <template v-slot:item.doAmount="{ item }">
          {{ formatPrice(item.doAmount) }}
        </template>
        <template v-slot:item.statusRfs="{ item }">
          {{ item.statusRfs == 1 ? "Full" : "Partial" }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: "query-do",
  data: () => ({
    headers: [
      {
        id: 9,
        text: "PO Date",
        value: "poDate",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 9,
        text: "PO Num",
        value: "poNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 11,
        text: "Cust Name",
        value: "customerName",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 9,
        text: "Curr",
        value: "currency",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 9,
        text: "PO Amount",
        value: "poAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 11,
        text: "DO Date",
        value: "doDate",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 9,
        text: "DO Num",
        value: "doNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 9,
        text: "DO Amount",
        value: "doAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 11,
        text: "Status",
        value: "statusRfs",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 11,
        text: "Aging",
        value: "aging",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    items: [],
    type: 0,
    search: "",
  }),

  methods: {
    find() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("saleInvoice/queryDO", this.type)
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleInvoice/queryDOExcel", this.type)
        .then(response => {
          fileDownload(response.data, "query-do.xlsx");
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  mounted() {
    this.find();
  },
};
</script>

<style></style>
